export const API_URL = import.meta.env.VITE_SMARTPARK_API_URL as string;
export const MEDIA_URL = import.meta.env.VITE_SMARTPARK_MEDIA_URL as string;
export const JWT_SECRET = '123456' as string;
